import { authUserCurrentWorkspaceFields } from 'features/user/api/authUser'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { gql } from 'providers/tanstack-query/utils'

import type { Data, VariablesDTO } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const UPDATE_CURRENT_WORKSPACE = (
  ability: Ability,
): TypedDocumentNode<Data, { input: VariablesDTO }> => gql`
  ${ERROR_FRAGMENT}

  mutation updateCurrentWorkspace($input: UpdateCurrentWorkspaceInput!) {
    updateCurrentWorkspace(input: $input) {
      user {
        currentWorkspace {
          ${authUserCurrentWorkspaceFields(ability)}
        }
        currentWorkspaceRole
        id
        workspaceProducts {
          product
          status
        }
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
